<script>
import options from "./CheckoutBillingInfo.options";
export default options;
</script>

<template>
    <form id="checkoutform" method="post" :action="action" class="nti-checkout-billing">
        
        <input type="hidden" v-model="conditions" name="conditions">
        <input type="hidden" v-model="newsletter" name="newsletter">
        <section class="nti-checkout-billing__invoice-information">
            <h1 class="nti-webshop-checkout__title">{{ label.invoiceHeader }}</h1>
            <p class="nti-webshop-checkout__title-paragraph">{{ verifyLabel('paymentInfoSubTitleLabel') }}</p>
            <div class="nti-checkout-billing__section-wrapper">

                <template v-if="renderMobile">
                    <FormBase 
                        :label="label"
                        :form="mobileCheckoutForm" 
                        :displayValidationResult="displayValidationResult" 
                        class="nti-checkout-billing__section-wrapper" 
                    />
                </template>
                <template v-if="renderDesktop">
                    <FormBase 
                        :label="label"
                        :form="invoiceForm" 
                        :displayValidationResult="displayValidationResult" 
                        class="nti-checkout-billing__section-wrapper" 
                    />
                </template>

                
        
                <section class="nti-checkout-billing__section__bottom">
                    <article class="nti-checkout-billing__checkbox-container">
                        <label class="custom-control custom-checkbox nti-checkout-billing__checkbox">
                            <input type="checkbox" v-model="useAlternateDeliveryAddress" name="UseOtherInvoice" value="true" class="form-control custom-control-input" required="required">
                            <span class="custom-control-indicator"></span>
                            <span class="nti-checkout-billing__checkbox-label">{{ verifyLabel('useOtherBillingAddressLabel') }}</span>
                        </label>
                    </article>
                    <template v-if="showAlternateParticipantInputCheckbox">
                        <article class="nti-checkout-billing__checkbox-container">
                            <label class="custom-control custom-checkbox nti-checkout-billing__checkbox">
                                <input type="checkbox" class="form-control custom-control-input" name="DifferentParticipantThanBilling" v-model="alternateParticipant" >
                                <span class="custom-control-indicator"></span>
                                <span class="nti-checkout-billing__checkbox-label">{{ verifyLabel('alternateParticipant')}}</span>
                            </label>
                        </article>
                    </template>
                </section>
            </div>
        </section>

        <section class="nti-checkout-billing__delivery-information" v-if="useAlternateDeliveryAddress">
            <h1 class="nti-webshop-checkout__title">{{ verifyLabel('otherBillingAddressTitleLabel') }}</h1>
            <p class="nti-webshop-checkout__title-paragraph">{{ verifyLabel('otherBillingAddressSubTitleLabel') }}</p>

            <div class="nti-checkout-billing__section-wrapper">

                <FormBase 
                    :label="label"
                    :form="deliveryForm" 
                    :displayValidationResult="displayValidationResult" 
                    class="nti-checkout-billing__section-wrapper"
                />

            </div>

        </section>

        <CheckoutCourseParticipants 
            :formRaw="participantSignupForm" 
            :displayValidationResult="displayValidationResult"
            :startDisabled="startAlternateParticipantFieldsDisabled"
        />

    </form>
</template>